import { FlyOut } from './FlyOut';

export default FlyOut;
export type { FlyOutProps } from './types';
